import { $el } from 'src/scripts/utils/utils'
import { ModalButton } from '../../components/modal/modal-button'
import { ProductModal } from './product-modal'

export class ProductModalButton extends ModalButton {
  trigger(): void {
    super.trigger()
    const modal: ProductModal = $el(this.dataset.modal)
    modal?.openAndShowMediaById(this.dataset.mediaId)
  }
}
